export const CLAIMS_SUCCESS = 'CLAIMS_SUCCESS';
export const CLAIMS_FAILURE = 'CLAIMS_FAILURE';
export const CLAIMS_STARTED = 'CLAIMS_STARTED';
